import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface ToolsDetailsNCFilePerformanceUtilizationProps {}

const ToolsDetailsNCFilePerformanceUtilization: FC<ToolsDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="Tools">
      <Text>ToolsDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { ToolsDetailsNCFilePerformanceUtilization };
